/*
 * bootstrap-table - v1.6.0 - 2015-02-03
 * https://github.com/wenzhixin/bootstrap-table
 * Copyright (c) 2015 zhixin wen
 * Licensed MIT License
 */
!function(a) {
	"use strict";
	a.fn.bootstrapTable.locales["es-ca-en"] = {
		formatLoadingMessage : function() {
			return window.lang.translate("Carregant, esperi si us plau...");
		},
		formatRecordsPerPage : function(a) {
			return a + window.lang.translate(" registres per pàgina");
		},
		formatShowingRows : function(a, b, c) {
			return window.lang.translate("Mostrant ") + a + window.lang.translate(" a ") + b 
					+ window.lang.translate(" de ") + c + window.lang.translate(" filas");
		},
		formatSearch : function() {
			return window.lang.translate("Cerca");
		},
		formatNoMatches : function() {
			return window.lang.translate("No s'han trobat registres");
		}
	}, a.extend(a.fn.bootstrapTable.defaults,
			a.fn.bootstrapTable.locales["es-ca-en"])
}(jQuery);